export default [
	{
		type: "uni",
		id: 1,
		title: "Evaluation of the learning management system (LMS; e.g. Moodle, MS Teams, or similar).",
		items: [
			{
				id: 1,
				text: "The LMS is clearly laid out.",
			},
			{
				id: 2,
				text: "Overall, I believe that the LMS positively influences the quality of teaching.",
			},
			{
				id: 3,
				text: "With the help of the LMS, I was able to internalize the learning material more easily.",
			},
			{
				id: 4,
				text: "Through the content on the LMS, my interest in the subject of the course was strengthened.",
			},
			{
				id: 5,
				text: "With the LMS, I was able to delve deeper into the topics beyond the scope of the event.",
			},
			{
				id: 6,
				text: "Using the LMS contributed to the understanding of the content.",
			},
			{
				id: 7,
				text: "The quality of the content provided on the LMS was good.",
			},
			{
				id: 8,
				text: "The materials to be processed in online activities were suitable for the LMS.",
			},
			{
				id: 9,
				text: "The content of the materials to be worked on online was sufficiently prepared.",
			},
			{
				id: 10,
				text: "Overall, I learned more through the combination of face-to-face and online activities.",
			},
			{
				id: 11,
				text: "The online activities in this course were associated with clear tasks and objectives.",
			},
			{
				id: 12,
				text: "I felt well looked after during the online activities.",
			},
			{
				id: 13,
				text: "I would have learned more if the topics and assignments I worked on online had been covered in face-to-face sessions.",
			},
		],
	},
];
